"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearCategories = clearCategories;
exports.listCategories = listCategories;
exports.removeCategory = removeCategory;
exports.updateCategory = updateCategory;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _exchangeApiClient = require("@mulesoft/exchange-api-client");
var actionTypes = _interopRequireWildcard(require("./actionTypes"));
var sessionSelectors = _interopRequireWildcard(require("../session/selectors"));
var categoriesSelector = _interopRequireWildcard(require("./selectors"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function fetchCategoriesRequest(_ref) {
  var organizationId = _ref.organizationId,
    masterOrganizationId = _ref.masterOrganizationId;
  return {
    type: actionTypes.LIST_CATEGORIES.REQUEST,
    params: {
      organizationId: organizationId,
      masterOrganizationId: masterOrganizationId
    }
  };
}
function fetchCategoriesSuccess(_ref2) {
  var organizationId = _ref2.organizationId,
    masterOrganizationId = _ref2.masterOrganizationId,
    categories = _ref2.categories;
  return {
    type: actionTypes.LIST_CATEGORIES.SUCCESS,
    params: {
      organizationId: organizationId,
      masterOrganizationId: masterOrganizationId
    },
    result: categories
  };
}
function fetchCategoriesFailure() {
  return {
    type: actionTypes.LIST_CATEGORIES.FAILURE
  };
}

/** Gets reviews for the asset portal */
function listCategories(_ref3) {
  var organizationId = _ref3.organizationId,
    masterOrganizationId = _ref3.masterOrganizationId;
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(dispatch, getState, _ref4) {
      var config, state, categoriesFromState, context, categoryService, response, _t;
      return _regenerator.default.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            config = _ref4.config;
            state = getState();
            categoriesFromState = categoriesSelector.categories(state, {
              organizationId: masterOrganizationId
            });
            if (!categoriesFromState) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return", categoriesFromState);
          case 1:
            context = sessionSelectors.context(state);
            _context.prev = 2;
            dispatch(fetchCategoriesRequest({
              organizationId: organizationId,
              masterOrganizationId: masterOrganizationId
            }));
            categoryService = new _exchangeApiClient.CategoryService(config);
            _context.next = 3;
            return categoryService.list({
              context: context,
              organizationId: organizationId
            });
          case 3:
            response = _context.sent;
            if (response) {
              dispatch(fetchCategoriesSuccess({
                organizationId: organizationId,
                masterOrganizationId: masterOrganizationId,
                categories: response
              }));
            }
            return _context.abrupt("return", response);
          case 4:
            _context.prev = 4;
            _t = _context["catch"](2);
            dispatch(fetchCategoriesFailure());
            throw _t;
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 4]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }();
}
function clearCategories(_ref6) {
  var organizationId = _ref6.organizationId;
  return {
    type: actionTypes.CLEAR_CATEGORIES,
    organizationId: organizationId
  };
}
function removeCategory(_ref7) {
  var category = _ref7.category;
  return _objectSpread({
    type: actionTypes.REMOVE_CATEGORY
  }, category);
}
function updateCategory(_ref8) {
  var category = _ref8.category;
  return _objectSpread({
    type: actionTypes.UPDATE_CATEGORY
  }, category);
}
//# sourceMappingURL=actions.js.map